import { get } from 'lodash';

function isLockedRow(permissions) {
  return !get(permissions, 'can_view.authorization', false);
}

export default isLockedRow;
